import * as Icons from "lucide-react";
import type { Amenity } from "../config/amenities";
import { useLanguage } from "../i18n/LanguageContext";
import { IconChip } from "./IconChip";
import { ICON_3D, Icon3D } from "./Icon3D";

export const AmenityCard = ({ amenity, confirmed = true }: { amenity: Amenity; confirmed?: boolean }) => {
  const { t, tr } = useLanguage();
  const Icon = ((Icons as unknown as Record<string, Icons.LucideIcon>)[amenity.icon] ?? Icons.Check) as Icons.LucideIcon;
  const icon3d = ICON_3D[amenity.id];
  return (
    <div className="card group flex items-start gap-4 p-5 transition-shadow duration-200 hover:shadow-lg" data-testid={`amenity-${amenity.id}`}>
      {icon3d ? <Icon3D src={icon3d} size="sm" /> : <IconChip icon={Icon} />}
      <div className="min-w-0">
        <p className="font-semibold">{tr(amenity.label)}</p>
        {amenity.note && <p className="mt-1 text-sm text-charcoal-500 leading-relaxed">{tr(amenity.note)}</p>}
        <span className={`mt-2 inline-block rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${confirmed ? "bg-sand-50 text-charcoal-500" : "bg-clay-50 text-clay"}`}>{confirmed ? t.common.confirmed : t.common.unconfirmed}</span>
      </div>
    </div>
  );
};
